module.exports = __webpack_public_path__ + "media/assets/images/landing_mobile/step-2-e3511810cc02d4da6e5e3c83a2c0c92d.png";